import {
  CLEAR_PASS,
  GET_CARD_BEGIN,
  GET_CARD_SUCCESS,
  GET_CARD_FAILURE,
  CHARGE_CARD_BEGIN,
  CHARGE_CARD_SUCCESS,
  CHARGE_CARD_FAILURE,
} from 'actions/card';

const initialState = {
  cardType: null,
  cardNumber: null,
  amount: null,
  cardHolder: null,
  isBlocked: false,
  ogm: null,
  error: false,
  loading: false,
  charged: false,
  linked: false,
  fetched: false,
};

export default function card(state = initialState, action) {
  switch (action.type) {
    case CLEAR_PASS:
      return initialState;
    case GET_CARD_BEGIN:
      return { ...state, loading: true };
    case GET_CARD_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
        fetched: true,
        error: false,
      };
    case GET_CARD_FAILURE:
      return { ...state, error: action.error, loading: false };
    case CHARGE_CARD_BEGIN:
      return { ...state, loading: true };
    case CHARGE_CARD_FAILURE:
      return { ...state, error: action.error, loading: false };
    case CHARGE_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        charged: true,
        error: false,
      };
    default:
      return state;
  }
}
